import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { useI18n } from '@/composables/i18n';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { User } from '@/models/user';
import { lastDayOfNextMonth } from '@/utils/dates';
import { isEmpty, isNil } from '@/utils/misc';
import moment from 'moment';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ConsolesWizardStep',
  props: {
    value: null,
    authorizedConsoles: null,
    hidden: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: User) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: User, authorizedConsoles: ConsoleEnum[], hidden: boolean, loading: boolean };





const { t } = useI18n();

function toggleConsole(console: ConsoleEnum) {
  if (props.value.consoles.includes(console)) {
    props.value.consoles = props.value.consoles.filter((x) => x !== console);
    setConsoleActivationDate(console, null);
    setConsoleEndDate(console, null);
    if (
      console === ConsoleEnum.BC &&
      props.value.consoles.includes(ConsoleEnum.SFC)
    ) {
      // Clean SFC values when BC is cleaned
      props.value.consoles = props.value.consoles.filter(
        (x) => x !== ConsoleEnum.SFC,
      );
      setConsoleActivationDate(ConsoleEnum.SFC, null);
      setConsoleEndDate(ConsoleEnum.SFC, null);
    }
  } else {
    props.value.consoles = [...props.value.consoles, console];
    setConsoleActivationDate(console, new Date());
    if ([ConsoleEnum.BC, ConsoleEnum.SFC].includes(console)) {
      setConsoleEndDate(console, moment().endOf('year').toDate());
    }
  }
  emitNewValue();
}

function getConsoleMinimumEndDate(console: ConsoleEnum): Date | null {
  const activationDate = getConsoleActivationDate(console);
  if (activationDate === null) {
    return null;
  }
  return lastDayOfNextMonth(activationDate);
}

function setConsoleActivationDate(
  console: ConsoleEnum,
  date: Date | null,
): void {
  props.value.setConsoleActivationDate(console, date);
  emitNewValue();
}

function setConsoleEndDate(console: ConsoleEnum, date: Date | null): void {
  props.value.setConsoleEndDate(console, date);
  emitNewValue();
}

function emitNewValue() {
  emit('input', props.value);
}

function isToggleEnabled(console: ConsoleEnum): boolean {
  if (console === ConsoleEnum.SFC) {
    return props.value.consoles.includes(ConsoleEnum.BC);
  }
  return true;
}

function isConsoleEnabled(console: ConsoleEnum): boolean {
  return props.value.consoles.includes(console);
}

function getConsoleActivationDate(console: ConsoleEnum): Date | null {
  return props.value.getConsoleActivationDate(console);
}

function getConsoleEndDate(console: ConsoleEnum): Date | null {
  return props.value.getConsoleEndDate(console);
}

const isValid = computed(
  () =>
    (!props.value.consoles.includes(ConsoleEnum.WCC) ||
      (props.value.consoles.includes(ConsoleEnum.WCC) &&
        !isNil(props.value.wccActivationDate))) &&
    (!props.value.consoles.includes(ConsoleEnum.BC) ||
      (props.value.consoles.includes(ConsoleEnum.BC) &&
        !isNil(props.value.bcActivationDate))) &&
    (!props.value.consoles.includes(ConsoleEnum.SFC) ||
      (props.value.consoles.includes(ConsoleEnum.SFC) &&
        !isNil(props.value.sfcActivationDate))),
);

return { __sfc: true,props, emit, t, toggleConsole, getConsoleMinimumEndDate, setConsoleActivationDate, setConsoleEndDate, emitNewValue, isToggleEnabled, isConsoleEnabled, getConsoleActivationDate, getConsoleEndDate, isValid, WizardStep, isEmpty }
}

})